import script from "./LaporanMaterialView.vue?vue&type=script&setup=true&lang=js"
export * from "./LaporanMaterialView.vue?vue&type=script&setup=true&lang=js"

import "./LaporanMaterialView.vue?vue&type=style&index=0&id=71b613b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b613b0"]])

export default __exports__